module.exports = {"id":"205569","name":"James Ward-Prowse","rating":"77","photo":"./data/images/photos/4/205569.png","club":{"name":"Southampton","logo":"./data/images/clubs/Southampton.png"},"positions":["MD","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JamesWard-Prowse0.json
// module id = 1906
// module chunks = 0